import { ElMessage } from 'element-plus';
import { EtradeApiRequestBodyTemplate } from '../models/EtradeApiModels';
import { TimerTriggerConditions } from '@etp/etp-gain-bff-client/axios';

const validateFilters = (filters: any[], contextMessage = ''): boolean => {
  if (!filters || filters.length === 0) {
    return true;
  }

  for (let i = 0; i < filters.length; i++) {
    const filter = filters[i];
    const filterNum = i + 1;

    if (!filter.name || filter.name.trim() === '') {
      ElMessage.error(`Filter ${filterNum}${contextMessage}: Name is required`);
      return false;
    }

    if (!filter.operator || filter.operator.trim() === '') {
      ElMessage.error(
        `Filter ${filterNum}${contextMessage}: Operator is required`
      );
      return false;
    }
  }

  return true;
};

export const isDailyRepeatFrequencyValid = (
  timerConditions: TimerTriggerConditions,
  selectedDays: number[],
  daysRequestBodyTemplates: Record<number, EtradeApiRequestBodyTemplate>,
  getDayLabel: (dayValue: number) => string
): boolean => {
  if (!timerConditions.executionTime) {
    ElMessage.error('Execution time is required for daily run');
    return false;
  }
  if (!timerConditions.executionTimeZone) {
    ElMessage.error('Execution time zone is required for daily run');
    return false;
  }
  if (selectedDays.length === 0) {
    ElMessage.error(
      'Please select at least one day for daily scheduled execution'
    );
    return false;
  }

  for (const dayValue of selectedDays) {
    const daySettings = daysRequestBodyTemplates[dayValue];
    if (!daySettings) continue;

    if (
      !daySettings.reportViewName ||
      daySettings.reportViewName.trim() === ''
    ) {
      ElMessage.error(
        `Report View Name is required for ${getDayLabel(dayValue)}`
      );
      return false;
    }

    if (!daySettings.reportName || daySettings.reportName.trim() === '') {
      ElMessage.error(`Report Name is required for ${getDayLabel(dayValue)}`);
      return false;
    }

    if (
      !validateFilters(daySettings.filters, ` for ${getDayLabel(dayValue)}`)
    ) {
      return false;
    }
  }
  return true;
};

export const areOtherRepeatFrequenciesValid = (
  singleRequestBodyTemplate: EtradeApiRequestBodyTemplate
): boolean => {
  if (
    !singleRequestBodyTemplate.reportViewName ||
    singleRequestBodyTemplate.reportViewName.trim() === ''
  ) {
    ElMessage.error('Report View Name is required');
    return false;
  }

  if (
    !singleRequestBodyTemplate.reportName ||
    singleRequestBodyTemplate.reportName.trim() === ''
  ) {
    ElMessage.error('Report Name is required');
    return false;
  }

  if (!validateFilters(singleRequestBodyTemplate.filters)) {
    return false;
  }

  return true;
};
